module.exports = __webpack_public_path__ + "static/undraw_data_xmfy-5ff1f6f443ac63820b3de12810a01879.svg";